// eslint-disable-next-line import/prefer-default-export
export const CHANGE_THEME = 'CHANGE_THEME';
